import { render, staticRenderFns } from "./txt-primary.vue?vue&type=template&id=394d710e&scoped=true&"
import script from "./txt-primary.vue?vue&type=script&lang=js&"
export * from "./txt-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394d710e",
  null
  
)

export default component.exports